webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UrlInput__ = __webpack_require__(/*! @/components/UrlInput */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataList__ = __webpack_require__(/*! @/components/DataList */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppName__ = __webpack_require__(/*! @/components/AppName */ 28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		UrlInput: __WEBPACK_IMPORTED_MODULE_0__components_UrlInput__["a" /* default */],
		DataList: __WEBPACK_IMPORTED_MODULE_1__components_DataList__["a" /* default */],
		AppName: __WEBPACK_IMPORTED_MODULE_2__components_AppName__["a" /* default */]
	}
});

/***/ }),
/* 5 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UrlInput.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_XInput__ = __webpack_require__(/*! @/components/XInput */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(/*! @/utils */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers__ = __webpack_require__(/*! timers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_timers__);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			url: this.$store.state.url
		};
	},

	methods: {
		update: function update(url) {
			this.$store.commit('UPDATE_URL', { url: url });
			this.$store.dispatch('GET_DATA');
		},
		copy: function copy(url) {
			var _location = location,
			    protocol = _location.protocol,
			    hostname = _location.hostname,
			    port = _location.port,
			    pathname = _location.pathname;

			var ar = [protocol, '//', hostname];
			if (port !== 80 && port !== '') ar = ar.concat([':', port]);
			ar = ar.concat([pathname], '?url=', encodeURIComponent(url));
			var str = ar.join('');
			var r = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* copy */])(str);
			if (!r) prompt(this.$t('copy.failed'), str);else alert(this.$t('copy.success'));
		}
	},
	components: {
		XInput: __WEBPACK_IMPORTED_MODULE_0__components_XInput__["a" /* default */]
	}
});

/***/ }),
/* 6 */
/*!***********************************!*\
  !*** ./src/components/XInput.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_XInput_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./XInput.vue */ 7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d516942_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XInput_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1d516942","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./XInput.vue */ 21);
var disposed = false
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_XInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d516942_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\XInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d516942", Component.options)
  } else {
    hotAPI.reload("data-v-1d516942", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/XInput.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		value: {
			type: String,
			required: true
		}
	},
	data: function data() {
		return {
			text: this.value
		};
	},

	watch: {
		text: function text(v) {
			this.$emit('input', v);
		}
	}
});

/***/ }),
/* 8 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataList.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_KeyValue__ = __webpack_require__(/*! @/components/KeyValue */ 25);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	computed: {
		data: function data() {
			return this.$store.state.data;
		}
	},
	methods: {
		add: function add() {
			var key = prompt(this.$t('key.add'));
			if (!key) return;
			var hasDuplicate = this.$store.state.data.filter(function (d) {
				return d.key === key;
			}).length > 0;
			if (hasDuplicate) alert(this.$t('key.duplicate', { key: key }));else this.$store.dispatch('SET_VALUE', { key: key, value: '' });
		}
	},
	components: {
		KeyValue: __WEBPACK_IMPORTED_MODULE_0__components_KeyValue__["a" /* default */]
	}
});

/***/ }),
/* 9 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KeyValue.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_XInput__ = __webpack_require__(/*! @/components/XInput */ 6);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			k: this.data.key,
			v: this.data.value
		};
	},

	methods: {
		update: function update() {
			if (!this.k || !this.v) return;
			if (this.v === this.data.value) return; // Nothing change
			this.$store.dispatch('SET_VALUE', { key: this.k, value: this.v });
		},
		del: function del() {
			if (!this.k) return;
			this.$store.dispatch('DEL_VALUE', { key: this.k });
		}
	},
	components: {
		XInput: __WEBPACK_IMPORTED_MODULE_0__components_XInput__["a" /* default */]
	}
});

/***/ }),
/* 10 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppName.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__(/*! @/components/Loading */ 30);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] }
});

/***/ }),
/* 11 */,
/* 12 */
/*!****************************!*\
  !*** ./src/locale/en.json ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

module.exports = {"appname":"Apps Script DB","editor":"Editor","load":"Load","add":"Add","update":"Update","delete":"Delete","dburl":"Database Url","copy":{"success":"Copied!","failed":"Copy failed! Please copy the following url."},"key":{"add":"Key:","duplicate":"Key \"{key}\" already exists."}}

/***/ }),
/* 13 */
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\Users\Administrator\Documents\GitHub\apps-script-db\src\index.js */14);


/***/ }),
/* 14 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(/*! bootstrap/dist/css/bootstrap.css */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_runtime_esm_js__ = __webpack_require__(/*! vue/dist/vue.runtime.esm.js */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__querystring__ = __webpack_require__(/*! @/querystring */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App__ = __webpack_require__(/*! @/components/App */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(/*! @/store */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(/*! @/i18n */ 41);








Object(__WEBPACK_IMPORTED_MODULE_5__i18n__["b" /* loadLanguage */])(navigator.language).then(function (x) {
	return console.log('Language loaded: ' + x);
});
if (__WEBPACK_IMPORTED_MODULE_2__querystring__["a" /* default */].url) {
	__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('UPDATE_URL', { url: __WEBPACK_IMPORTED_MODULE_2__querystring__["a" /* default */].url });
}
if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.url) {
	__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('GET_DATA');
}

new __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_runtime_esm_js__["a" /* default */]({
	el: '#app',
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_3__components_App__["a" /* default */]);
	},
	store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
	i18n: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* i18n */]
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/*!****************************!*\
  !*** ./src/querystring.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (Object.assign.apply(Object, _toConsumableArray(location.search.replace(/^\?/, '').split('&').map(function (tok) {
	return tok.split('=');
}).map(function (k) {
	return _defineProperty({}, k[0], decodeURIComponent(k[1]));
}))));

/***/ }),
/* 19 */
/*!********************************!*\
  !*** ./src/components/App.vue ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cab9c1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-38cab9c1","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 34);
var disposed = false
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cab9c1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38cab9c1", Component.options)
  } else {
    hotAPI.reload("data-v-38cab9c1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/*!*************************************!*\
  !*** ./src/components/UrlInput.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_UrlInput_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./UrlInput.vue */ 5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f52cc2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UrlInput_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1f52cc2b","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./UrlInput.vue */ 23);
var disposed = false
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_UrlInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f52cc2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UrlInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\UrlInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f52cc2b", Component.options)
  } else {
    hotAPI.reload("data-v-1f52cc2b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d516942","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/XInput.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group" }, [
    _c("div", { staticClass: "input-group-prepend" }, [_vm._t("prepend")], 2),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.text,
          expression: "text"
        }
      ],
      staticClass: "form-control",
      attrs: { type: "text" },
      domProps: { value: _vm.text },
      on: {
        keyup: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          _vm.$emit("enter")
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.text = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "input-group-append" }, [_vm._t("append")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d516942", esExports)
  }
}

/***/ }),
/* 22 */
/*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/
/*! exports provided: copy */
/*! exports used: copy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
function copy(str) {
	var ta = document.createElement('textarea');
	ta.value = str;
	document.body.appendChild(ta);
	ta.focus();
	ta.select();

	var result = void 0;
	try {
		result = document.execCommand('copy');
	} catch (err) {
		result = false;
	}

	document.body.removeChild(ta);
	return result;
}

/***/ }),
/* 23 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f52cc2b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UrlInput.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "x-input",
        {
          on: {
            enter: function($event) {
              _vm.update(_vm.url)
            }
          },
          model: {
            value: _vm.url,
            callback: function($$v) {
              _vm.url = $$v
            },
            expression: "url"
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "input-group-text",
              attrs: { slot: "prepend" },
              on: {
                click: function($event) {
                  _vm.copy(_vm.url)
                }
              },
              slot: "prepend"
            },
            [_vm._v(_vm._s(_vm.$t("dburl")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { slot: "append" },
              on: {
                click: function($event) {
                  _vm.update(_vm.url)
                }
              },
              slot: "append"
            },
            [_vm._v(_vm._s(_vm.$t("load")))]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f52cc2b", esExports)
  }
}

/***/ }),
/* 24 */
/*!*************************************!*\
  !*** ./src/components/DataList.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DataList_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DataList.vue */ 8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_006f9d78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataList_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-006f9d78","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DataList.vue */ 27);
var disposed = false
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DataList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_006f9d78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\DataList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-006f9d78", Component.options)
  } else {
    hotAPI.reload("data-v-006f9d78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/*!*************************************!*\
  !*** ./src/components/KeyValue.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KeyValue_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./KeyValue.vue */ 9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171e0f62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyValue_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-171e0f62","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./KeyValue.vue */ 26);
var disposed = false
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KeyValue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171e0f62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyValue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\KeyValue.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-171e0f62", Component.options)
  } else {
    hotAPI.reload("data-v-171e0f62", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-171e0f62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KeyValue.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "x-input",
          {
            on: { enter: _vm.update },
            model: {
              value: _vm.v,
              callback: function($$v) {
                _vm.v = $$v
              },
              expression: "v"
            }
          },
          [
            _c(
              "span",
              {
                staticClass: "input-group-text",
                attrs: { slot: "prepend" },
                slot: "prepend"
              },
              [_vm._v(_vm._s(_vm.k))]
            ),
            _vm._v(" "),
            _c("template", { slot: "append" }, [
              _c(
                "button",
                { staticClass: "btn btn-primary", on: { click: _vm.update } },
                [_vm._v(_vm._s(_vm.$t("update")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-danger", on: { click: _vm.del } },
                [_vm._v(_vm._s(_vm.$t("delete")))]
              )
            ])
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-171e0f62", esExports)
  }
}

/***/ }),
/* 27 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-006f9d78","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataList.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm._l(_vm.data, function(d, idx) {
          return _c("key-value", {
            key: d.key,
            class: { "pt-2": idx > 0 },
            attrs: { data: d }
          })
        }),
        _vm._v(" "),
        _vm.data
          ? _c("div", { staticClass: "row pt-2" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary w-100",
                    on: { click: _vm.add }
                  },
                  [_vm._v(_vm._s(_vm.$t("add")))]
                )
              ])
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-006f9d78", esExports)
  }
}

/***/ }),
/* 28 */
/*!************************************!*\
  !*** ./src/components/AppName.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AppName_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["C://Users//Administrator//Documents//GitHub//apps-script-db//node_modules//babel-preset-poi//index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppName.vue */ 10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5cec328_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppName_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-d5cec328","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppName.vue */ 33);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-d5cec328","scoped":true,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AppName.vue */ 29)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5cec328"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AppName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5cec328_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppName_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\AppName.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d5cec328", Component.options)
  } else {
    hotAPI.reload("data-v-d5cec328", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d5cec328","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppName.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/*!************************************!*\
  !*** ./src/components/Loading.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2605d148_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2605d148","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Loading.vue */ 32);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2605d148","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Loading.vue */ 31)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2605d148_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\Loading.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2605d148", Component.options)
  } else {
    hotAPI.rerender("data-v-2605d148", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2605d148","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loading.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2605d148","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function(_h, _vm) {
  var _c = _vm._c
  return _vm.props.loading
    ? _c("div", { staticClass: "spinner" }, [
        _c("div", { staticClass: "rect1" }),
        _vm._v(" "),
        _c("div", { staticClass: "rect2" }),
        _vm._v(" "),
        _c("div", { staticClass: "rect3" }),
        _vm._v(" "),
        _c("div", { staticClass: "rect4" }),
        _vm._v(" "),
        _c("div", { staticClass: "rect5" })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2605d148", esExports)
  }
}

/***/ }),
/* 33 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5cec328","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppName.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block" }, [
    _c("h1", { staticClass: "pr-2 block-item" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://github.com/maple3142/apps-script-db",
            target: "_blank"
          }
        },
        [_vm._v(_vm._s(_vm.$t("appname")))]
      ),
      _vm._v(" " + _vm._s(_vm.$t("editor")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "block-item" },
      [_c("loading", { attrs: { loading: _vm.$store.state.loading } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5cec328", esExports)
  }
}

/***/ }),
/* 34 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38cab9c1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row pt-2" }, [
      _c("div", { staticClass: "col-12" }, [_c("app-name")], 1)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row pt-2" }, [
      _c("div", { staticClass: "col-12" }, [_c("url-input")], 1)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row pt-2" }, [
      _c("div", { staticClass: "col-12" }, [_c("data-list")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38cab9c1", esExports)
  }
}

/***/ }),
/* 35 */
/*!**********************!*\
  !*** ./src/store.js ***!
  \**********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_storage__ = __webpack_require__(/*! vuejs-storage */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apps_script_db__ = __webpack_require__(/*! apps-script-db */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apps_script_db___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_apps_script_db__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
	state: {
		url: '',
		data: null,
		loading: false,
		success: false
	},
	mutations: {
		UPDATE_URL: function UPDATE_URL(state, _ref) {
			var url = _ref.url;

			state.url = url;
		},
		UPDATE_DATA: function UPDATE_DATA(state, _ref2) {
			var data = _ref2.data;
			return state.data = data;
		},
		START_LOADING: function START_LOADING(state) {
			return state.loading = true;
		},
		STOP_LOADING: function STOP_LOADING(state) {
			return state.loading = false;
		},
		SUCCESS: function SUCCESS(state) {
			return state.success = true;
		},
		FAILED: function FAILED(state) {
			return state.success = false;
		}
	},
	actions: {
		GET_DATA: function () {
			var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref3) {
				var commit = _ref3.commit,
				    state = _ref3.state;
				var db, data;
				return __WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (state.url) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								db = new __WEBPACK_IMPORTED_MODULE_4_apps_script_db___default.a(state.url, window.fetch.bind(window));

								commit('START_LOADING');
								_context.prev = 4;
								_context.t0 = JSON;
								_context.next = 8;
								return db.get('*');

							case 8:
								_context.t1 = _context.sent;
								data = _context.t0.parse.call(_context.t0, _context.t1);

								commit('UPDATE_DATA', {
									data: Object.keys(data).map(function (key) {
										return {
											key: key,
											value: data[key]
										};
									})
								});
								_context.next = 18;
								break;

							case 13:
								_context.prev = 13;
								_context.t2 = _context['catch'](4);

								commit('STOP_LOADING');
								commit('UPDATE_DATA', { data: null });
								return _context.abrupt('return');

							case 18:
								_context.prev = 18;

								commit('STOP_LOADING');
								return _context.finish(18);

							case 21:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[4, 13, 18, 21]]);
			}));

			function GET_DATA(_x) {
				return _ref4.apply(this, arguments);
			}

			return GET_DATA;
		}(),
		SET_VALUE: function () {
			var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5, _ref6) {
				var commit = _ref5.commit,
				    dispatch = _ref5.dispatch,
				    state = _ref5.state;
				var key = _ref6.key,
				    value = _ref6.value;
				var db;
				return __WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (state.url) {
									_context2.next = 2;
									break;
								}

								return _context2.abrupt('return');

							case 2:
								db = new __WEBPACK_IMPORTED_MODULE_4_apps_script_db___default.a(state.url);

								commit('START_LOADING');
								_context2.next = 6;
								return db.set(key, value);

							case 6:
								commit('STOP_LOADING');
								dispatch('GET_DATA');

							case 8:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function SET_VALUE(_x2, _x3) {
				return _ref7.apply(this, arguments);
			}

			return SET_VALUE;
		}(),
		DEL_VALUE: function () {
			var _ref10 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8, _ref9) {
				var commit = _ref8.commit,
				    dispatch = _ref8.dispatch,
				    state = _ref8.state;
				var key = _ref9.key;
				var db;
				return __WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (state.url) {
									_context3.next = 2;
									break;
								}

								return _context3.abrupt('return');

							case 2:
								db = new __WEBPACK_IMPORTED_MODULE_4_apps_script_db___default.a(state.url);

								commit('START_LOADING');
								_context3.next = 6;
								return db.del(key);

							case 6:
								commit('STOP_LOADING');
								dispatch('GET_DATA');

							case 8:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function DEL_VALUE(_x4, _x5) {
				return _ref10.apply(this, arguments);
			}

			return DEL_VALUE;
		}()
	}
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/*!*********************!*\
  !*** ./src/i18n.js ***!
  \*********************/
/*! exports provided: i18n, supportedLanguages, loadLanguage */
/*! exports used: i18n, loadLanguage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
/* unused harmony export supportedLanguages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(/*! vue-i18n */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale_en_json__ = __webpack_require__(/*! @/locale/en.json */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__locale_en_json__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
	locale: navigator.language,
	fallbackLocale: 'en',
	messages: { en: __WEBPACK_IMPORTED_MODULE_3__locale_en_json___default.a }
});

var supportedLanguages = ['en', 'zh-tw'];

var loadLanguage = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(lang) {
		var msgs;
		return __WEBPACK_IMPORTED_MODULE_0_C_Users_Administrator_Documents_GitHub_apps_script_db_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						lang = lang.toLowerCase();

						if (supportedLanguages.includes(lang)) {
							_context.next = 3;
							break;
						}

						return _context.abrupt('return');

					case 3:
						_context.next = 5;
						return __webpack_require__(/*! ./locale */ 43)("./" + lang + '.json');

					case 5:
						msgs = _context.sent;

						i18n.setLocaleMessage(lang, msgs);
						i18n.locale = lang;
						document.querySelector('html').setAttribute('lang', lang);
						return _context.abrupt('return', lang);

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadLanguage(_x) {
		return _ref.apply(this, arguments);
	};
}();

/***/ }),
/* 42 */,
/* 43 */
/*!****************************************!*\
  !*** ./src/locale lazy ^\.\/.*\.json$ ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": [
		12
	],
	"./zh-tw.json": [
		44,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 43;
module.exports = webpackAsyncContext;

/***/ })
],[13]);


// WEBPACK FOOTER //
// client.b6a1a5bf.js